module.exports = __webpack_public_path__ + "static/media/bo-eva.73944d66.png";